var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "주문 관리",
      "showsFilterButton": ""
    },
    model: {
      value: _vm.showsSearch,
      callback: function ($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('purchase-list-search', _vm._b({}, 'purchase-list-search', {
    showsSearch: _vm.showsSearch
  }, false)), _c('v-row', [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "outlined": "",
      "rounded": ""
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "green--text px-2",
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.excel
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("엑셀다운로드")], 1)], 1)], 1)], 1), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    attrs: {
      "items-per-page": -1,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.numbers`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', [_c('order-view', {
          attrs: {
            "_order": item._order
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref3) {
              var _item$order;
              var attrs = _ref3.attrs,
                on = _ref3.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "pa-0 caption",
                attrs: {
                  "x-small": "",
                  "text": "",
                  "tile": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v(_vm._s((_item$order = item.order) === null || _item$order === void 0 ? void 0 : _item$order.orderNo))])];
            }
          }], null, true)
        })], 1), _c('div', [_vm._v(_vm._s(item.purchaseNo))])];
      }
    }, {
      key: `item.order.sender`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          class: {
            'red--text': item.user ? item.user.isWarning : false
          }
        }, [_vm._v(_vm._s(item.order.sender.name))]), _c('div', {
          class: {
            'red--text': item.user ? item.user.isWarning : false
          }
        }, [_vm._v(_vm._s(item.order.sender.phone))]), _c('div', {
          class: {
            'red--text': item.user ? item.user.isWarning : false
          }
        }, [_vm._v(_vm._s(item.order.sender.email))])];
      }
    }, {
      key: `item.order.receiver`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('div', [_vm._v(_vm._s(item.order.receiver.name))]), _c('div', [_vm._v(_vm._s(item.order.receiver.phone))]), _c('div', [_vm._v(_vm._s(item.order.receiver.email))])];
      }
    }, {
      key: `item.order.receiver.address`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('div', [_vm._v("[" + _vm._s(item.order.receiver.postcode) + "]")]), _c('div', [_vm._v(_vm._s(item.order.receiver.address1) + " " + _vm._s(item.order.receiver.address2))])];
      }
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    loading: _vm.loading
  }, false)), _c('v-pagination', {
    staticClass: "my-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }